/*
  LOOW pack selector (1/3/5) behaviour. Loaded once from layout/theme.liquid
  right after theme.js (both defer), so it exists before any selector is
  inserted dynamically (theme editor section load, quick-shop innerHTML).

  Responsibilities:
  - write the chosen quantity into the add-to-cart form (hidden quantity
    input rendered by snippets/loow-pack-selector.liquid, or the theme's own
    .js-qty__num when a template has a quantity_selector block),
  - recompute everything on variant change (theme "variantChange" event),
  - apply the same rules as the loow-pack-discount function: each tier's DKK
    saving is converted with Shopify.currency.rate and rounded to whole
    units (exact in DKK), a tier applies only while that saving is below the
    pack price, and the saving shown for a quantity is the best combination
    of applicable packs (so 2:100 + 5:150 shows 200 for five),
  - format money with theme.Currency.formatMoney in whole units when the
    currency is converted.

  All options are always rendered by Liquid; visibility is decided here from
  the current variant's price, so a pack hidden at one price returns when
  the customer picks a dearer variant.
*/
(function () {
  'use strict';

  function wholeUnitFormat(format) {
    return String(format)
      .replace('amount_with_comma_separator', 'amount_no_decimals_with_comma_separator')
      .replace('amount_with_space_separator', 'amount_no_decimals_with_space_separator')
      .replace(/\{\{\s*amount\s*\}\}/, '{{amount_no_decimals}}');
  }

  function formatMoney(minor, isDkk) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function' && theme.settings) {
      var format = isDkk ? theme.settings.moneyFormat : wholeUnitFormat(theme.settings.moneyFormat);
      return theme.Currency.formatMoney(minor, format);
    }
    return null;
  }

  function currencyRate(isDkk) {
    if (isDkk) return 1;
    var rate = window.Shopify && window.Shopify.currency ? Number(window.Shopify.currency.rate) : NaN;
    return rate > 0 ? rate : null;
  }

  // Same as pack_rules.js: DKK saving -> minor units of the cart currency.
  function toPresentmentMinor(offDkk, rate) {
    return rate === 1 ? offDkk * 100 : Math.round(offDkk * rate) * 100;
  }

  // Same as pack_rules.js savingsFor: unbounded knapsack over 0..qty.
  function savingsFor(qty, tiers) {
    if (!(qty > 0) || tiers.length === 0) return 0;
    var best = [];
    for (var i = 0; i <= qty; i++) best[i] = 0;
    for (var q = 1; q <= qty; q++) {
      var value = best[q - 1];
      for (var t = 0; t < tiers.length; t++) {
        if (tiers[t].qty <= q) {
          var candidate = best[q - tiers[t].qty] + tiers[t].offMinor;
          if (candidate > value) value = candidate;
        }
      }
      best[q] = value;
    }
    return best[qty];
  }

  function initOne(root) {
    if (root.dataset.init) return;
    root.dataset.init = '1';

    var formId = root.dataset.formId;
    var isDkk = root.dataset.isDkk === 'true';
    var unit = Number(root.dataset.unitMinor) || 0;
    var labelSave = root.dataset.labelSave || 'Spar';
    var unitLabel = root.dataset.unitLabel || '';

    // Exactly one quantity field may post with the form.
    var hidden = root.querySelector('[data-loow-pack-qty]');
    var themeQty = formId ? document.querySelector('.js-qty__num[form="' + formId + '"]') : null;
    var qtyInput = hidden;
    if (themeQty) {
      if (hidden) hidden.parentNode.removeChild(hidden);
      qtyInput = themeQty;
    }

    var options = Array.prototype.slice.call(root.querySelectorAll('[data-loow-pack-option]'));

    function setQty(value) {
      if (!qtyInput) return;
      qtyInput.value = String(value);
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function repaint() {
      var rate = currencyRate(isDkk);
      var canFormat = formatMoney(0, isDkk) !== null;
      if (rate === null || !canFormat) {
        // Amounts stay hidden (data-pending); quantity choice still works.
        return;
      }

      var tiers = [];
      options.forEach(function (option) {
        var qty = Number(option.dataset.qty) || 1;
        if (qty > 1) tiers.push({ qty: qty, offMinor: toPresentmentMinor(Number(option.dataset.offDkk) || 0, rate) });
      });
      var valid = tiers.filter(function (t) { return unit > 0 && t.offMinor < t.qty * unit; });

      var validPacks = 0;
      var hiddenChecked = false;

      options.forEach(function (option) {
        var qty = Number(option.dataset.qty) || 1;
        var totalEl = option.querySelector('[data-pack-total]');
        var perEl = option.querySelector('[data-pack-per]');
        var saveEl = option.querySelector('[data-pack-save]');
        var input = option.querySelector('input[type="radio"]');

        if (qty === 1) {
          if (totalEl) totalEl.innerHTML = formatMoney(unit, isDkk);
          option.hidden = false;
          return;
        }

        var applies = valid.some(function (t) { return t.qty === qty; });
        option.hidden = !applies;
        if (!applies) {
          if (input && input.checked) hiddenChecked = true;
          return;
        }
        validPacks += 1;
        var saving = savingsFor(qty, valid);
        var total = unit * qty - saving;
        if (totalEl) totalEl.innerHTML = formatMoney(total, isDkk);
        if (perEl) perEl.innerHTML = formatMoney(Math.round(total / qty), isDkk) + '/' + unitLabel;
        if (saveEl) saveEl.innerHTML = labelSave + ' ' + formatMoney(saving, isDkk);
      });

      if (hiddenChecked) {
        var first = options[0] && options[0].querySelector('input[type="radio"]');
        if (first) first.checked = true;
        setQty(1);
      }

      root.hidden = validPacks === 0;
      if (root.hidden) setQty(1);
      root.removeAttribute('data-pending');
    }

    root.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || target.type !== 'radio') return;
      setQty(Number(target.value) || 1);
    });

    var section = root.closest('[data-section-id]') || root.closest('.product-section');
    if (section) {
      section.addEventListener('variantChange', function (event) {
        var variant = event.detail && event.detail.variant;
        if (!variant || typeof variant.price !== 'number') return;
        unit = variant.price;
        repaint();
      });
    }

    var checked = null;
    for (var i = 0; i < options.length; i++) {
      var radio = options[i].querySelector('input[type="radio"]');
      if (radio && radio.checked) { checked = options[i]; break; }
    }
    setQty(checked ? Number(checked.dataset.qty) || 1 : 1);
    repaint();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-loow-pack]:not([data-init])');
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
  }

  var scheduled = false;
  function scheduleInit() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      initAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', scheduleInit);
  document.addEventListener('shopify:section:reorder', scheduleInit);

  if (window.MutationObserver && document.body) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.hasAttribute('data-loow-pack') || node.querySelector('[data-loow-pack]')) {
            scheduleInit();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
